import React from "react";
import Image from "next/image";
import Link from "next/link";
import suffleIcon from "../images/shuffle-icon.png";
import { useEffect, useState } from "react";
import { strapi_end_point } from "../config";
const qs = require("qs");
export default function ShuffleBits() {
  const [slug, setSlug] = useState("");
  const [isLoading, setLoading] = useState(true);
  const GetRandomSlug = (data) => {
    const rand = Math.floor(Math.random() * Math.floor(data.length));
    setSlug(data[rand].attributes.slug);
  };
  useEffect(() => {
    const query = qs.stringify(
      {
        sort: ["sorting:asc"],
        fields: ["slug"],
        pagination: {
          pageSize: 25,
          page: 1,
        },
        publicationState: "live",
        locale: ["en"],
      },
      {
        encodeValuesOnly: true, // prettify url
      }
    );
    fetch(`${strapi_end_point}/api/bits-categories?${query}`)
      .then((res) => res.json())
      .then((data) => {
        GetRandomSlug(Array.from(data.data));
        setLoading(false);
      });
  }, []);
  return isLoading ? (
    <div className="suffle-icon fixed bottom-[80px] flex items-center justify-center sm:hidden right-[30px] bg-white w-12 h-12 rounded-full shadow-lg">
      <i className="fas fa-spinner fa-spin text-xl text-white"></i>
    </div>
  ) : (
    <Link href={`/category/${slug}`}>
      <a>
        <div className="suffle-icon fixed bottom-[80px] flex items-center justify-center sm:hidden right-[30px] bg-white w-12 h-12 rounded-full shadow-lg z-[40]">
          <Image src={suffleIcon} alt="" width={35} height={35} />
        </div>
      </a>
    </Link>
  );
}
